import * as THREE from 'three';
import { createTextMesh } from './MeshHelpers';

Array.prototype.quickRemove = function (element) {
  var index = this.indexOf(element);
  if (index !== -1) {
    this[index] = this[this.length - 1];
    this.pop();
  }
};

export let debug = process.env.NODE_ENV !== 'production';

export function hexToNumber(hex) {
  if (hex[0] === '#') hex = hex.substring(1);
  return parseInt(hex, 16);
}

export function isHex(hex) {
  var regex = /^\#?[0-9A-F]{6}$/i;
  return regex.test(hex);
}

export function forEachIfArray(obj, func, arrayToTest) {
  var args = Array.from(arguments).splice(3);
  if (arrayToTest instanceof Array) {
    for (var i = 0; i < arrayToTest.length; i++) {
      args.unshift(arrayToTest[i]);
      func.apply(obj, args);
      args.shift();
    }
  } else {
    args.unshift(arrayToTest);
    func.apply(obj, args);
    args.shift();
  }
}

export function isNumber(n) {
  return Number(n) === n;
}

export function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}

export function isFloat(n) {
  return Number(n) === n && n % 1 !== 0;
}

export function alert(msg) {
  alert('WindowDrawer: ' + msg);
}

export function asArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return [obj];
}

function getVerticesRecursive(obj, result) {
  if (obj.geometry && obj.geometry.vertices) {
    var vertices = obj.geometry.vertices;
    vertices.forEach(v => {
      var localVertex = new THREE.Vector3(v.x, v.y, v.z);
      var worldVertex = obj.localToWorld(localVertex);
      result.push(worldVertex);
    });
  }

  obj.children.forEach(child => {
    getVerticesRecursive(child, result);
  });
}

export function getVertices(obj) {
  var result = [];
  obj.updateMatrixWorld();
  getVerticesRecursive(obj, result);
  return result;
}

export function roundVertices(geometry, fractionDigits = 6) {
  const mul = Math.pow(10, fractionDigits);
  geometry.vertices.forEach(v => {
    v.x = Math.round(v.x * mul) / mul;
    v.y = Math.round(v.y * mul) / mul;
    v.z = Math.round(v.z * mul) / mul;
  });
}

export function darkenColor(color, amount) {
  let r = color & 0xff;
  let g = (color & 0xff00) >> 8;
  let b = (color & 0xff0000) >> 16;
  const a = (color & 0xff000000) >> 24;

  const invAmount = 1 - amount;
  r *= invAmount;
  g *= invAmount;
  b *= invAmount;

  return r | (g << 8) | (b << 16) | (a << 24);
}

THREE.Mesh.prototype.buildEdges = function (opacity, thresholdAngle = 10.0) {
  if (opacity === undefined) opacity = 1;
  var edges = new THREE.EdgesGeometry(this.geometry, thresholdAngle);
  var lines = new THREE.LineSegments(
    edges,
    new THREE.LineBasicMaterial({
      color: 0x999999,
      transparent: opacity < 1,
      opacity: opacity,
    })
  );
  this.add(lines);
};

THREE.Mesh.prototype.buildEdgesNoDepthTest = function (opacity) {
  if (opacity === undefined) opacity = 1;
  var edges = new THREE.EdgesGeometry(this.geometry);
  var lines = new THREE.LineSegments(
    edges,
    new THREE.LineBasicMaterial({
      color: 0x999999,
      transparent: opacity < 1,
      opacity: opacity,
      depthTest: false,
    })
  );
  this.add(lines);
};

THREE.Mesh.prototype.buildText = function (text, size) {
  var textObjData = createTextMesh(text, size);
  textObjData.mesh.position.z += this.data.b / 2 + 1e-3;
  this.add(textObjData.mesh);
};
